/**
 * @enum string
 */
export const DATE_FORMATS = {
  YMD       : 'YMD',
  DMY       : 'DMY',
  MDY       : 'MDY',
  WORDS_DM  : 'WORDS_DM',
  WORDS_DMY : 'WORDS_DMY',

  DMY_SHORT_YEAR: 'DMY_SHORT_YEAR'
};

export const DAY_WEEKS = ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'];
export const MONTHS = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
export const MONTHS_ABBR = ['Янв', 'Февр', 'Март', 'Апр', 'Мая', 'Июня', 'Июля', 'Авг', 'Сент', 'Окт', 'Нояб', 'Дек'];
export const DAY_WEEKS_FROM = ['воскресенья', 'понедельника', 'вторника', 'среды', 'четверга', 'пятницы', 'субботы'];
export const DAY_WEEKS_WHEN = ['В воскресенье', 'В понедельник', 'Во вторник', 'В среду', 'В четверг', 'В пятницу', 'В субботу'];

/**
 * @param {string} dateString
 * @param {DATE_FORMATS} format
 *
 * @return {day, month, year}
 */
export function extractFromDateStringByFormat(dateString, format) {
  let day;
  let month;
  let year;

  if (format === DATE_FORMATS.YMD) {
    const [
      extractedYear,
      extractedMonth,
      extractedDay
    ] = dateString.split('-').map((x) => parseInt(x, 10));

    day = extractedDay;
    month = extractedMonth;
    year = extractedYear;
  } else if (format === DATE_FORMATS.DMY) {
    const [
      extractedDay,
      extractedMonth,
      extractedYear
    ] = dateString.split('.').map((x) => parseInt(x, 10));

    day = extractedDay;
    month = extractedMonth;
    year = extractedYear;
  }

  return {
    day,
    month,
    year
  };
}

/**
 * @param {string} dateString
 * @param {DATE_FORMATS} format
 *
 * @return Date|null
 */
export function parseDate(dateString, format) {
  const {
    day,
    month,
    year
  } = extractFromDateStringByFormat(dateString, format);

  if (!day || !month || !year) {
    return null;
  }

  const date = new Date();

  date.setDate(day);
  date.setMonth(month - 1);
  date.setFullYear(year);

  return date;
}

/**
 * @param {Date} date
 * @param {DATE_FORMATS} format
 *
 * @return string
 */
export function formatDate(date, format) {
  const [
    day,
    month,
    year
  ] = [date.getDate(), date.getMonth() + 1, date.getFullYear()].map((x) => String(x));

  switch (format) {
    case DATE_FORMATS.YMD:
      return `${year.padStart(4, '0')}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;

    case DATE_FORMATS.DMY:
      return `${day.padStart(2, '0')}.${month.padStart(2, '0')}.${year.padStart(4, '0')}`;

    case DATE_FORMATS.DMY_SHORT_YEAR:
      return `${day.padStart(2, '0')}.${month.padStart(2, '0')}.${year.toString().slice(-2)}`;

    case DATE_FORMATS.MDY:
      return `${month.padStart(2, '0')}.${day.padStart(2, '0')}.${year.padStart(4, '0')}`;

    case DATE_FORMATS.WORDS_DM:
      return `${day} ${MONTHS[month - 1]}`;

    case DATE_FORMATS.WORDS_DMY:
      return `${day} ${MONTHS[month - 1]} ${year.padStart(4, '0')}`;

    default:
      return '';
  }
}

/**
 * Get the number of days in any particular month
 * @link https://stackoverflow.com/a/1433119/1293256
 * @param  {integer} m The month (valid: 0-11)
 * @param  {integer} y The year
 * @return {integer}   The number of days in the month
 */
export function daysInMonth(m, y) {
  switch (m) {
    case 1:
      return (y % 4 === 0 && y % 100) || y % 400 === 0 ? 29 : 28;

    case 8:
    case 3:
    case 5:
    case 10:
      return 30;

    default:
      return 31;
  }
}

/**
* Check if a date is valid
* @link https://stackoverflow.com/a/1433119/1293256
* @param  {[type]}  d The day
* @param  {[type]}  m The month
* @param  {[type]}  y The year
* @return {Boolean}   Returns true if valid
*/
export function isValidDate(d, m, y) {
  const month = parseInt(m, 10) - 1;
  return month >= 0 && month < 12 && d > 0 && d <= daysInMonth(month, y);
}

export const getCurrentMoscowTime = () => {
  // Создаем объект Date с текущей датой и временем
  const now = new Date();

  // Получаем смещение времени в минутах для московского времени (UTC+3)
  const moscowOffset = 180; // Московское время UTC+3

  // Получаем текущее время в UTC
  const utcTime = now.getTime() + (now.getTimezoneOffset() * 60000);

  // Создаем новый объект Date с учетом московского времени
  return new Date(utcTime + (moscowOffset * 60000));
};
